<template>
    <div class="fx fx-c_stretch">
        <div class="fx-g1 edit_panel" @click="activeItem = null" v-loading="uploading">
            <el-form :inline="true">
                <el-form-item label="所属项目">
                    <Select :url="`/pbl/selectData/project`" :value="query.projectId"
                        @optionChanged="this.optionChanged"
                        :bindDisabled="String(query.projectId)==''?false:true"></Select>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-upload action="" accept="image/*,text/plain,application/zip,video/*,
                        application/rar,application/vnd.ms-powerpoint,
                        application/msword,
                        application/vnd.ms-excel,
                        application/pdf,application/doc,
                        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                        application/vnd.openxmlformats-officedocument.presentationml.presentation"
                        :on-remove="removeFile" :before-upload="insertFile" :file-list="fileList"
                        :show-file-list="false" multiple>
                        <el-button type="primary">上传文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div style="display: flex;align-items: center" class="fx fx-wrap fx-w_start">
                <div v-for="(item, i) in tableData" :key="i" @contextmenu.stop.prevent
                    @mouseup.prevent.stop="showMenu(item)" @dblclick="enter(item)" >
                    <div v-if="item.file" style="width: 170px; height: 230px;">
                        <file-preview v-if="!item.file.isVideo" :key="i" :allow-preview="true" :allow-download="true"
                            :allow-play="true" width="150" height="150" class="file_icon" :hide-name="true"
                            :url="item.file.url" @play="play"></file-preview>
                        <video v-else :src="item.file.url" controls preload="metadata"
                            style="width: 150px;height: 150px;border:1px solid #d9dee8;border-radius: 4px"></video>
                        <div v-html="item.file.name" style="text-align: center;word-wrap: break-word; "></div>
                    </div>
                </div>
            </div>
            <ul class="menu" ref="menu">
                <li @click.stop="doDelete"><i class="fa fa-trash"></i>删除</li>
            </ul>
        </div>
    </div>
</template>
<style>
    .content_div img {
        width: 100%;
    }
</style>

<script>
    import Select from "@/components/Select.vue";

    export default {
        components: {
            Select
        },
        data() {
            return {
                navs: [{
                    id: 0,
                    title: "首页"
                }],
                query: {
                    projectId: "",
                    ...this.attr
                },
                tableData: [],
                activeItem: {},
                fileList: [],
                uploading: false,
            };
        },
        props: {
            attr: {
                type: Object,
                default: () => ({
                    showBack: false
                })
            }
        },
        watch: {
            activeItem: function(newValue) {
                if (newValue == null) {
                    this.hideMenu();
                }
            },
            query: {
                handler: function(newValue) {
                    this.tableData = [];
                    this.loadData();
                },
                deep: true
            }
        },
        computed: {},
        created() {
            this.loadData();
        },
        methods: {
            //拿到视频地址,播放
            play(url) {

            },
            enter(item) {
                if (item.type == 1) {
                    this.navs.push(item);
                }
            },
            showMenu: function(item) {
                //文件右键
                if (event.button == 2) {
                    //右键
                    this.activeItem = item;
                    let menu = this.$refs.menu;
                    menu.style.left = event.pageX + "px";
                    menu.style.top = event.pageY + "px";
                    menu.style.display = "block";
                } else {
                    this.hideMenu();
                }
            },
            hideMenu: function() {
                this.$refs.menu.style.display = "none";
            },
            doDelete() {
                this.$ajaxGet(
                    "/pbl/file/institution/delete/" + this.activeItem.id,
                    data => {
                        this.loadData();
                        this.hideMenu();
                    }
                );
            },
            insertFile(file) { //上传文件
                //在这里要先判断一下,上次doc跟docx的内容不能为空,否则就算上传成功,在线查看的时候也会报错
                const docType = file.name.substring(file.name.lastIndexOf(".") + 1);
                if ((docType == 'doc' || docType == 'docx') && file.size <= 9216) {
                    this.$showError("您上传的资料:【" + file.name + "】的内容为空,请填写内容后在提交");
                    return;
                }

                const projectId = this.query.projectId || "";
                if (projectId === "") {
                    this.$showError("请选择项目");
                    return;
                }
                // if (file.size / 1048576 > 200) {
                //     this.$showError("禁止上传超过200M大小文件");
                //     return;
                // }
                this.uploading = true;
                this.$uploadQiniu(file, "PBL/", {
                    success: file => {
                        let newFile = {};
                        newFile.projectId = this.query.projectId;
                        newFile.fileList = [];
                        newFile.fileList.push(file);
                        this.$ajaxPost(
                            "/pbl/file/institution/insert", {
                                file: newFile
                            },
                            data => {
                                this.uploading = false;
                                this.loadData();
                            }
                        );
                    }
                });
            },
            removeFile(file) {
                this.fileList = this.fileList.filter(item => item.uid != file.uid);
            },
            loadData() {
                const projectId = this.query.projectId || "";
                if (projectId === "") {
                    return;
                }
                this.$ajaxPost(
                    "/pbl/file/institution/list", {
                        query: this.query
                    },
                    data => {
                        this.tableData = data.result;
                        console.log(this.tableData);
                    }
                );
            },
            optionChanged(result) {
                this.query.projectId = result.value;
            },

        }
    };
</script>

<style scoped>
    .navs {
        list-style: none;
        padding-left: 5px;
        letter-spacing: 2px;
        margin: 15px 0px;
    }

    .navs li {
        cursor: pointer;
        font-weight: bold;
    }

    .navs li:hover {
        color: var(--primary);
    }

    .menu li {
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
    }

    .menu li:hover {
        background: var(--primary);
        color: white;
        cursor: pointer;
    }

    .menu {
        width: 90px;
        border: 1px solid #cacaca;
        padding: 8px 10px;
        border-radius: 6px;
        background: rgba(251, 251, 251, 0.82);
        font-size: 16px;
        display: none;
        position: fixed;
        list-style: none;
    }

    .menu li {
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
    }

    .menu li:hover {
        background: var(--primary);
        color: white;
        cursor: pointer;
    }

    .content_div img {
        width: 100%;
    }

    .edit_panel {
        background: white;
        padding: 10px 60px;
    }

    .edit_form {
        width: 70%;
    }

    .custom-tree-node {
        padding: 2px 5px 0;
    }

    .custom-tree-node.active {
        background: #dadada;
    }

    .title_div {
        width: 92%;
        padding-left: 25px;
        background-color: #ddd;
        height: 94%;
        margin-left: 5px;
        border-radius: 5px;
        font-size: 18px;
        color: inherit;
        font-weight: bold;
    }

    .file_icon>>>.file_preview-icon i.iconfont {
        font-size: 100px;
    }
</style>
